import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
	root: {
		'& .logo-icon': {
			width: '15%',
			// background:'black',
			height: '100%',
			marginTop: "0px",
			transition: theme.transitions.create(['width', 'height'], {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		},
		'& .react-badge, & .logo-text': {
			transition: theme.transitions.create('opacity', {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		}
	},
	reactBadge: {
		backgroundColor: '#121212',
		color: '#61DAFB'
	}
}));

function Logo() {
	const classes = useStyles();

	return (
		<div className={clsx(classes.root, 'flex items-center')}>
			{/* <img className="logo-icon" src="assets/images/logos/fuse.png" alt="logo" /> */}
			{/* <img className="logo-icon" src="assets/images/logos/solomonLogo.png" alt="logo" width="50" height="10"/> */}
			<div className="" style={{ width: '100px' }}>
				<img className="" src="assets/images/logos/logo1.png" alt="logo" width="50" height="100" />
			</div>
			<div className="" style={{ marginLeft: '15px' }}>
				<img className="" src="assets/images/logos/logo2.png" alt="logo" width="275" height="150" />
			</div>



			{/* <div className="headerTopic"> Solomons International practical wisdom at work</div> */}
			{/* <div style={{ display: "flex", width: "100%", marginLeft: "75%" }}>
				<p style={{ color: "#293B96" }} >Welcome back Paul</p>
				<span style={{ color: '#293b96', fontSize: "2rem", cursor: "pointer", paddingLeft: "2px" }} class="material-icons MuiIcon-root text-28 MuiIcon-colorAction" aria-hidden="true">call</span>
			</div> */}

			{/* <Typography className="text-16 mx-12 font-light logo-text" color="inherit">
				FUSE
			</Typography>
			<div className={clsx(classes.reactBadge, 'react-badge flex items-center py-4 px-8 rounded')}>
				<img
					className="react-logo"
					src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K"
					alt="react"
					width="16"
				/>
				<span className="react-text text-12 mx-4">React</span>
			</div> */}
		</div>
	);
}

export default Logo;
